import { create } from 'zustand';

type TypeTooltip = {
  show: boolean;
  description: React.ReactNode;
  title?: React.ReactNode;
  maxWidth?: number;
};

type TypeTooltipStore = {
  tooltip: TypeTooltip;
  setTooltip: (tooltip: TypeTooltip) => void;
};

export const useTooltipStore = create<TypeTooltipStore>((set) => ({
  tooltip: { show: false, description: '', title: undefined, maxWidth: undefined },
  setTooltip: (tooltip) => set({ tooltip }),
}));
